import React, { useEffect, useState } from 'react';
import { BRAND } from '../config/region';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import ParticleBackground from './ParticleBackground';
import SeoHead from './SeoHead';
import { apiGet, apiPost } from '../utils/apiUtils';
import { API_URLS } from '../config/api';
import { t } from '../i18n';
import './NewsPage.css';

const NewsPage = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [unseenCount, setUnseenCount] = useState(0);

  useEffect(() => {
    // Capture how many posts are unseen BEFORE marking them read, so we can
    // highlight them on this visit. The list is newest-first, so the first
    // `unseenCount` cards are exactly the unseen ones.
    apiGet(API_URLS.NEWS_UNREAD_COUNT, {}, false, '', true)
      .then(res => setUnseenCount(res.data?.count || 0))
      .catch(() => {})
      .finally(() => {
        apiGet(API_URLS.NEWS)
          .then(res => { setPosts(res.data); setLoading(false); })
          .catch(() => setLoading(false));
        // Mark read + clear the header badge AFTER the count was captured above.
        apiPost(API_URLS.NEWS_MARK_READ, {}, {}, false, '', true).catch(() => {});
        window.dispatchEvent(new Event('newsRead'));
      });
  }, []);

  return (
    <div className="np-wrap">
      <SeoHead
        title={t('Новости')}
        description={t('Новости и обновления платформы {0}.', BRAND)}
      />
      <ParticleBackground />
      <div className="np-app">
        <div className="np-header">
          <h1 className="np-title">{t('Новости')}</h1>
          <p className="np-subtitle">{t('Обновления и анонсы платформы')}</p>
        </div>

        {loading ? (
          <div className="np-empty">{t('Загрузка...')}</div>
        ) : posts.length === 0 ? (
          <div className="np-empty">{t('Новостей пока нет')}</div>
        ) : (
          <div className="np-list">
            {posts.map((post, i) => (
              <Link
                key={post.id}
                to={`/news/${post.slug}`}
                className={`np-card${i < unseenCount ? ' np-card--new' : ''}`}
              >
                <div className="np-card-text">
                  <h2 className="np-card-title">
                    {post.title}
                    {i < unseenCount && <span className="np-card-new-badge">{t('Новое')}</span>}
                  </h2>
                  <span className="np-card-date">
                    {new Date(post.created_at).toLocaleDateString('ru-RU', {
                      day: 'numeric', month: 'long', year: 'numeric'
                    })}
                  </span>
                </div>
                <ChevronRight size={18} className="np-card-arrow" />
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default NewsPage;
